const GOAL = 4999;

function updateCartGoal(){

fetch('/cart.js')
.then(res => res.json())
.then(cart => {

const cartTotal = cart.total_price / 100;
const remaining = Math.max(GOAL - cartTotal, 0);
let progress = (cartTotal / GOAL) * 100;

if(progress > 100) progress = 100;

document.querySelectorAll(".cart-goal-wrapper").forEach(wrapper => {

const bar = wrapper.querySelector("#goal-bar-fill");
const message = wrapper.querySelector("#goal-message");

if(!bar || !message) return;

bar.style.width = progress + "%";

if(cartTotal >= GOAL){

message.innerHTML =
"🎉 Congratulations! Your FREE Surprise Worth ₹499 is unlocked!";

if(!window.confettiPlayed){
launchConfetti();
window.confettiPlayed = true;
}

}else{

message.innerHTML =
"Buy above ₹4999 on Prepaid & Get FREE Surprise Worth ₹499!" +
"<span>Add ₹"+remaining.toFixed(0)+" more to unlock 🎁</span>";

}

});

});

}

function launchConfetti(){

const duration = 1200;
const end = Date.now() + duration;

(function frame(){

confetti({
particleCount:6,
spread:60,
origin:{ y:0.6 }
});

if(Date.now() < end){
requestAnimationFrame(frame);
}

})();

}

/* run on page load */
document.addEventListener("DOMContentLoaded", updateCartGoal);

/* run when drawer opens */
document.addEventListener("click", function(e){

if(e.target.closest(".m-cart-toggle")){
setTimeout(updateCartGoal, 400);
}

});

/* run when cart updates */
document.addEventListener("cart:updated", updateCartGoal);

/* backup refresh every second */
setInterval(updateCartGoal, 1000);